import type { SVGProps } from 'react'
const SvgDropArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="5"
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.140625 0.75L3.89062 4.5L7.64062 0.75H0.140625Z"
      fill="#007CF0"
    />
  </svg>
)
export default SvgDropArrow
